<template>
    <base-component :taxpayerInfo="currentTaxpayer">
        <template slot="form">
            <ticket-search-form :fetch="fetchData" :taxpayerInfo="currentTaxpayer || $route.params" :pageSize="pageSize" :offset="offset" :setOffset="setOffset"/>
        </template>
        <template slot="workArea">
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>
            <b-card :no-body="!isOperator" class="flex-fill flex-shrink-0">
                <b-tabs v-if="!isOperator" card>
                    <b-tab :title="$t('menu.kkms')" @click="openKkms"></b-tab>
                    <b-tab v-if="!isInspector" :title="$t('menu.blockedKkms')" @click="openBlockedKkms"></b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.reports')" @click="openReports"></b-tab>
                    <b-tab :title="$t('menu.tickets')" active>
                        <pagination :pageSize="this.pageSize" :offset="offset" :listLength="tickets.length" :setOffset="setOffset"/>
                        <b-table :items="tickets" :fields="fields" class="table-borderless" striped small show-empty>
                            <template slot="debet" slot-scope="row">
                                {{ row.item.debet ? $t('ticket.expense') : $t('ticket.income') }}
                            </template>
                            <template slot="txnClientDate" slot-scope="row">
                                {{ $d(row.item.txnClientDate, 'long') }}
                            </template>
                            <template slot="actions" slot-scope="row">
                                <b-dropdown variant="link">
                                    <template slot="button-content">
                                        <dots-icon title="" />
                                    </template>
                                    <b-dd-item v-if="isTaxpayer" target="_blank" :to="{ name: 'ticketDetails', params: row.item }">{{ $t('general.details') }}</b-dd-item>
                                    <b-dd-item v-else target="_blank" :to="{ name: 'childTicketDetails', params: row.item }">{{ $t('general.details') }}</b-dd-item>
                                    <b-dd-item v-if="isTaxpayer || isOperator" @click.stop="openSellReturnModal(row)">{{ $t('menu.sellReturn') }}</b-dd-item>
                                </b-dropdown>
                            </template>
                            <template slot="empty">
                                <div class="text-center">
                                    {{ $t('general.noData') }}
                                </div>
                            </template>
                        </b-table>
                    </b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.moneyPlacements')" @click="openMoneyPlacements"></b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.tasks')" @click="openTasks"/>
                </b-tabs>

                <div v-else>
                    <pagination :pageSize="this.pageSize" :offset="offset" :listLength="tickets.length" :setOffset="setOffset"/>
                        <b-table :items="tickets" :fields="fields" class="table-borderless" striped small show-empty>
                            <template slot="debet" slot-scope="row">
                                {{ row.item.debet ? $t('ticket.expense') : $t('ticket.income') }}
                            </template>
                            <template slot="txnClientDate" slot-scope="row">
                                {{ $d(row.item.txnClientDate, 'long') }}
                            </template>
                            <template slot="actions" slot-scope="row">
                                <b-dropdown variant="link">
                                    <template slot="button-content">
                                        <dots-icon title="" />
                                    </template>
                                    <b-dd-item v-if="isTaxpayer || isOperator" target="_blank" :to="{ name: 'ticketDetails', params: row.item }">{{ $t('general.details') }}</b-dd-item>
                                    <b-dd-item v-else target="_blank" :to="{ name: 'childTicketDetails', params: row.item }">{{ $t('general.details') }}</b-dd-item>
                                    <b-dd-item v-if="isTaxpayer || isOperator" @click.stop="openSellReturnModal(row)">{{ $t('menu.sellReturn') }}</b-dd-item>
                                </b-dropdown>
                            </template>
                            <template slot="empty">
                                <div class="text-center">
                                    {{ $t('general.noData') }}
                                </div>
                            </template>
                        </b-table>
                </div>

                <b-modal ref="sellReturnConfirmModal" :title="$t('menu.sellReturn')"
                    @ok="returnSell" :cancel-title="$t('general.cancel')" lazy>
                    <p>{{ $t('ticket.sellReturnConfirmation', [clickedTicket.onlineTicketNumber]) }}</p>
                </b-modal>
                <b-modal ref="sellReturnedModal" :title="$t('menu.sellReturn')" ok-only lazy>
                    <b-alert variant="success" show>{{ $t('ticket.sellReturnedMessage') }}</b-alert>
                </b-modal>
                <b-modal ref="sellReturnErrorModal" :title="$t('menu.sellReturn')" ok-only lazy>
                    <b-alert variant="danger" show>{{ alert }}</b-alert>
                </b-modal>
            </b-card>
        </template>
    </base-component>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata'
const TicketSearchForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/ticket/TicketSearchForm.vue')
const Pagination = () => import(/* webpackChunkName: "chunk-views" */ '@/components/general/Pagination.vue')

export default {
    name: 'Tickets',
    mixins: [ AppData ],
    components: {
        TicketSearchForm,
        Pagination
    },
    data () {
        return {
            showAlert: false,
            alert: '',
            tickets: [],
            clickedTicket: {},
            pageSize: 20,
            offset: 0
        }
    },
    mounted () {
        this.getCurrentTaxpayer()
    },
    computed: {
        fields: function () {
            return [
                { key: 'ccmFactoryNumber', label: this.$t('ticket.kkmFactoryNum'), sortable: true },
                { key: 'shiftNumber', label: this.$t('ticket.shiftNumber'), sortable: true },
                { key: 'shiftDocumentNumber', label: this.$t('ticket.shiftDocumentNumber'), sortable: true },
                { key: 'offlineTicketNumber', label: this.$t('ticket.offlineTicketNumber'), sortable: true },
                { key: 'onlineTicketNumber', label: this.$t('ticket.onlineTicketNumber'), sortable: true },
                { key: 'debet', label: this.$t('ticket.debet') },
                { key: 'totalAmount', label: this.$t('ticket.totalAmount') },
                { key: 'cashierName', label: this.$t('ticket.cashierName'), sortable: true },
                { key: 'txnClientDate', label: this.$t('ticket.txnClientDate'), sortable: true },
                { key: 'actions', label: this.$t('general.actions') }
            ]
        }
    },
    methods: {
        fetchData: function (formData) {
            this.hideAlert()
            if (this.offset === 0) {
                formData.txnClientEndDate = formData.txnClientEndDateForm
            }

            const onSuccess = response => {
                this.tickets = [];

                if (!Array.isArray(response))
                    throw new Error('Server must be returns array');

                for (let ticket of response){

                    if (ticket.txnClientDate != null)
                        ticket.txnClientDate = new Date(ticket.txnClientDate);
                    
                    this.tickets.push(ticket);
                }

                if (this.offset === 0 && this.tickets[0] != null) {
                    formData.txnClientEndDate = this.tickets[0].txnClientDate;
                    formData.txnClientEndDate.setMilliseconds(formData.txnClientEndDate.getMilliseconds() + 1); // todo
                }

            }

            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.ticket.get,
                formData,
                onSuccess,
                this.displayAlert);
        },
        openSellReturnModal: function (row) {
            this.clickedTicket = row.item
            this.$refs.sellReturnConfirmModal.show()
        },
        returnSell: function () {
            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.ticket.sellReturn,
                {
                    ccmId: this.clickedTicket.ccmId,
                    txnClientId: this.clickedTicket.txnClientId
                }, response => {
                    this.$refs.sellReturnedModal.show()
                }, error => {
                    this.alert = this.$t(`errors.${error}`)
                    this.$refs.sellReturnErrorModal.show()
                })
        },
        setOffset: function (newValue) {
            this.offset = newValue
        },
        openKkms: function () {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'kkms' })
            } else {
                this.$router.push({ name: 'childKkm' })
            }
        },
        openReports: function () {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'reports' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childReports' })
            }
        },
        openMoneyPlacements: function () {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'moneyPlacements' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childMoneyPlacements' })
            }
        },
        openBlockedKkms: function () {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'kkmsBlocked' })
            } else if (this.isOperator) {
                this.$router.push({ name: 'blockedKkms' })
            }
        },
        openTasks() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'tasks' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childTasks' })
            }
        }
    }
}
</script>
